module.exports = __webpack_public_path__ + "static/media/tp.1ac10b1c.png";